import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchCompanies } from 'Redux/Admin/Companies/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { ICompany } from 'Redux/Admin/Companies/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const SLUG = "companies";

const columns: TableColumnsType<ICompany> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/${SLUG}/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
];

const Companies = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  /* const projectPlan = params.get('project_plan');
  const searchValue = params.get('search'); */
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchCompaniesReducer);

  useEffect(() => {
    dispatch(fetchCompanies({ /* project_plan: projectPlan, search: searchValue,  */offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [/* projectPlan, searchValue,  */pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    /* {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search by name'
    }, */
    /* {
      type: 'project-plan-select',
      paramName: 'project_plan',
      placeholder: 'Select project plan...',
      label: 'Project Plan'
    }, */
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<ICompany>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/${SLUG}/new`}
      filters={filterConfigs}
    />
  );
}

export default Companies;
